import { observer } from 'mobx-react-lite';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isSingleLineListView } from 'owa-mail-layout';
import { getDensityModeString } from 'owa-session-store';
import * as React from 'react';

const styles = require('./MessageAdListStubElement.scss');
const classNames = require('classnames/bind').bind(styles);

const MessageAdListPreloadingStubElement = observer(function MessageAdListPreloadingStubElement() {
    const useAdViewOneLine = isSingleLineListView();
    const useAdsExp = isFeatureEnabled('adsExp-NativeUX-treatment');

    const oneLineContainer = useAdsExp
        ? classNames(getDensityModeString(), styles.messageAdStaticContainerOneLineExp)
        : styles.messageAdStaticContainerOneLine;
    const threeLinesContainer = useAdsExp
        ? classNames(getDensityModeString(), styles.messageAdStaticContainerThreeLineExp)
        : styles.messageAdStaticContainerThreeLine;
    return <div className={useAdViewOneLine ? oneLineContainer : threeLinesContainer} />;
});
export default MessageAdListPreloadingStubElement;
